// src/utils/stockFormatter.js

/**
 * Formats inventory quantity into tiered threshold displays:
 * - > 50: "50+ in Stock" (or "100+ in Stock")
 * - > 10: "10+ in Stock" (or "20+ in Stock")
 * - 1 to 10: "N in Stock"
 * - <= 0: "Out of Stock"
 */
export const formatStockDisplay = (quantity, language = "en") => {
  const isFr = language && language.toLowerCase().startsWith("fr");
  const qty = Number(quantity);

  if (!Number.isFinite(qty) || qty <= 0) {
    return {
      text: isFr ? "Rupture de stock" : "Out of stock",
      cardText: isFr ? "Rupture" : "Out of Stock",
      shortText: isFr ? "Épuisé" : "Out of stock",
      inStock: false,
      badgeColor: "text-red-600 dark:text-red-400 bg-red-500/10 border-red-500/20",
      dotColor: "bg-red-500",
      urgency: "out",
      count: 0,
    };
  }

  if (qty >= 100) {
    return {
      text: isFr ? "100+ en stock" : "100+ in stock",
      cardText: isFr ? "100+ en stock" : "100+ in Stock",
      shortText: "100+",
      inStock: true,
      badgeColor: "text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/25",
      dotColor: "bg-emerald-500",
      urgency: "plenty",
      count: qty,
    };
  }

  if (qty >= 50) {
    return {
      text: isFr ? "50+ en stock" : "50+ in stock",
      cardText: isFr ? "50+ en stock" : "50+ in Stock",
      shortText: "50+",
      inStock: true,
      badgeColor: "text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/25",
      dotColor: "bg-emerald-500",
      urgency: "plenty",
      count: qty,
    };
  }

  if (qty >= 20) {
    return {
      text: isFr ? "20+ en stock" : "20+ in stock",
      cardText: isFr ? "20+ en stock" : "20+ in Stock",
      shortText: "20+",
      inStock: true,
      badgeColor: "text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/25",
      dotColor: "bg-emerald-500",
      urgency: "high",
      count: qty,
    };
  }

  if (qty > 10) {
    return {
      text: isFr ? "10+ en stock" : "10+ in stock",
      cardText: isFr ? "10+ en stock" : "10+ in Stock",
      shortText: "10+",
      inStock: true,
      badgeColor: "text-emerald-700 dark:text-emerald-300 bg-emerald-500/10 border-emerald-500/25",
      dotColor: "bg-emerald-500",
      urgency: "medium",
      count: qty,
    };
  }

  if (qty === 1) {
    return {
      text: isFr ? "Plus que 1 en stock" : "Only 1 left in stock",
      cardText: isFr ? "1 en stock" : "1 in Stock",
      shortText: isFr ? "1 restant" : "Only 1 left",
      inStock: true,
      badgeColor: "text-amber-700 dark:text-amber-300 bg-amber-500/10 border-amber-500/25",
      dotColor: "bg-amber-500",
      urgency: "low",
      count: 1,
    };
  }

  return {
    text: isFr ? `Plus que ${qty} en stock` : `Only ${qty} left in stock`,
    cardText: isFr ? `${qty} en stock` : `${qty} in Stock`,
    shortText: isFr ? `${qty} restants` : `${qty} left`,
    inStock: true,
    badgeColor: "text-amber-700 dark:text-amber-300 bg-amber-500/10 border-amber-500/25",
    dotColor: "bg-amber-500",
    urgency: "low",
    count: qty,
  };
};
